module.exports = __webpack_public_path__ + "img/Delivery_hand_done.69eb2d0f.png";